/**
 * UK Vehicle Registration Number (VRN) normalization and validation.
 *
 * Mirrors backend rules (ATT-78 / ATT-152): trim whitespace, strip internal
 * spaces, uppercase, alphanumeric only, length 2-7. Keep the rules in sync
 * with `project/checks/motor_vehicle/uk_mot_check/v1/...` on the backend.
 */

export const VRN_MIN_LENGTH = 2;
export const VRN_MAX_LENGTH = 7;

const VRN_ALLOWED_REGEX = /^[A-Z0-9]+$/;

export function normalizeVRN(input: string): string {
  return input.replace(/\s+/g, "").toUpperCase();
}

export type VRNValidationError =
  | "REQUIRED"
  | "TOO_SHORT"
  | "TOO_LONG"
  | "INVALID_CHARACTERS";

export function validateVRN(input: string): VRNValidationError | null {
  const normalized = normalizeVRN(input);

  if (normalized.length === 0) {
    return "REQUIRED";
  }
  if (normalized.length < VRN_MIN_LENGTH) {
    return "TOO_SHORT";
  }
  if (normalized.length > VRN_MAX_LENGTH) {
    return "TOO_LONG";
  }
  if (!VRN_ALLOWED_REGEX.test(normalized)) {
    return "INVALID_CHARACTERS";
  }

  return null;
}
